<template>
    <div class="container__out__mobile" v-if="windowWidth <= 700" ref="containerOut">
        <dv5-collapse-mobile v-for="(filter, index) in filters" :key="index" :options="filters" :view="filter" :toolsSelected="toolsSelected">
            <span :slot="'title'" slot-scope="props" :class="props.titleClass">{{filter.mobile_name}}</span>
            <dv5-shared-carousel
                :slot="'content'"
                slot-scope="props"
                :key="this.filter * 2"
                :view="slideArr"
                :swipe="true"
                :swipeToSlide="true"
                :slidesToShow="1"
                :slidesToScroll="1"
            >
                <div
                    :slot="'slide'"
                    slot-scope="props"
                    :class="props.slideClass"
                >
                    <dv5-multiline-slide-grid-h
                        :view="props.slide"
                        :rows="selectedBreakpoint.settings.rows"
                        :cols="selectedBreakpoint.settings.cols"

                    >
                        <tools-cards
                            v-for="(card, index) in props.slide"
                            :key="index"
                            :view="card"
                            :isMobile="true"
                            v-bind:t="t"
                            v-bind:data="dataCard"/>
                    </dv5-multiline-slide-grid-h>
                </div>
            </dv5-shared-carousel>
        </dv5-collapse-mobile>
    </div>
    <div class="container__out" v-else-if="windowWidth > 700" ref="containerOut">
        <div class="top_filter" v-show="filters != 0">
            <div class="display_flex item_strech justify_c_between">
                <div class="filters_1 item_strech display_flex">
                    <button v-if="windowWidth >= 1920" v-for="(option, index) in filters" :key="index" @click="toolsSelected(index)"
                            :class="[ (option.name != t.label_legacy && option.name != t.office_filter_new && option.name != t.office_filter_beta) ? 'button4 simple' : 'button4 badge', option.isActive == true ? 'is-active' : '' ]">
                        <div :class="[ (option.name == t.label_legacy || option.name == t.office_filter_new) ? 'lateral_bar' : '', option.name == t.office_filter_new ? 'new' : '', option.name == t.label_legacy ? 'legacy' : '']"></div>
                        <img v-if="option.lateral_line" class="beta_img" :src="`${option.lateral_line}`">
                        <img v-if="option.icon" class="beta_icon" :src="`${option.icon}`">
                        <span :class="[ option.name == t.label_legacy ? 'legacy' : '', option.name == t.office_filter_new ? 'new' : '' ]">{{ option.name }}</span>
                    </button>
                    <dv5-multiselect v-if="windowWidth < 1920 && windowWidth > 700" :translations="this.view['translation']" v-bind:view="filters" :toolsSelected="toolsSelected"/>
                </div>
                <div class="filters_1 item_strech display_flex">
                    <div v-show=" windowWidth > 1180" class="button4 simple display_flex item_center">
                        <input type="search" v-model="search" placeholder="Builderall Builder, Mailingboss, ..."/>
                        <img :src="`/internacional/public/office5/img/general-svg/search_icon.svg`">
                    </div>
                    <div v-show="filter === 0 && windowWidth > 700"
                         class="button4 simple display_flex item_center" @click="showModal = true"
                         data-toggle="tooltip"
                         data-placement="bottom"
                         :title="view.translation.tools.v5_tooltip_drag_and_drop">
                        <span v-show="windowWidth >2000">{{ t.V5_priorities }}</span>
                        <img :src="`/internacional/public/office5/img/general-svg/drag-and-drop.svg`">
                    </div>
                </div>
            </div>
        </div>

        <div class="list-group" v-if="processing && !ready">
            <span class="container__tool container__tool--loading">
                <div class="card__tool" v-for="i in shimmerCardNumber" :key="i">
                    <div class="card__content">
                        <div class="header__tool"></div>
                        <div class="body__tool">
                            <h3></h3>
                            <span v-for="z in 5" :key="z"></span>
                        </div>
                    </div>

                    <div class="card__actions">
                        <div class="footer__help" v-if="!langToShowNewCardFormat">
                            <div class="help__help"><a></a><i></i></div>
                            <div class="help__trainning"><a></a><i></i> </div>
                        </div>
                        <div v-else class="footer__help">
                            <div class="help__help__us"><a></a><i></i></div>
                        </div>
                        <div class="footer__actions" v-if="!langToShowNewCardFormat">
                            <a></a><a></a>
                        </div>
                        <div v-else class="footer__actions__us">
                            <a></a>
                        </div>
                    </div>
                </div>
            </span>
        </div>

        <dv5-shared-carousel
            :key="filter"
            :view="slideArr"
            :swipe="true"
            :swipeToSlide="true"
            :slidesToShow="1"
            :slidesToScroll="1"
            :responsive="[
                {
                    'breakpoint': 100000,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1,
                        'dots': true,
                        'arrows': true,
                    }
                },
                {
                    'breakpoint': 1920,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1,
                        'dots': true,
                        'arrows': true,
                    }
                },
                {
                    'breakpoint': 1366,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1,
                        'dots': true,
                        'arrows': true,
                    }
                },
                {
                    'breakpoint': 1024,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1,
                        'dots': true,
                        'arrows': true,
                    }
                },
                {
                    'breakpoint': 768,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1,
                        'dots': true,
                        'arrows': true,
                    }
                },
                {
                    'breakpoint': 700,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1,
                        'dots': true,
                        'arrows': true,
                    }
                },
            ]"
        >
            <div
                class="slide-wrapper"
                :slot="'slide'"
                slot-scope="props"
                :class="props.slideClass"
            >
                <dv5-multiline-slide-grid-h
                    :view="props.slide"
                    :rows="selectedBreakpoint.settings.rows"
                    :cols="selectedBreakpoint.settings.cols"

                >
                    <tools-cards
                        v-for="(card, index) in props.slide"
                        :key="index"
                        :view="card"
                        :isMobile="false"
                        v-bind:t="t"
                        v-bind:data="dataCard"/>
                </dv5-multiline-slide-grid-h>
            </div>
        </dv5-shared-carousel>

        <transition name="fade" mode="out-in">
            <div class="modal-overlay display_flex justify_c_center" key="modal" v-if="showModal">
                <div class="box_congratulation display_flex column_flex">
                    <div class="display_flex content_end">
                        <button class="button4 exit glyphicon glyphicon-remove" style="color:red" @click="showModal = false"/>
                    </div>
                    <div class="display_flex column_flex item_center">
                        <span class="dv5_DaD_title">{{ t.V5_DaD_Title }}
                            <SpringSpinner
                                v-if="savingTools"
                                class="loader"
                                :animation-duration="2500"
                                :size="20"
                                color="#A5B9D5"
                            />
                        </span>
                        <span class="dv5_DaD_subtitle">{{ t.V5_DaD_Subtitle }}</span>
                        <div class="tool-suggestion-container">
                            <span class="dv5_DaD_subtitle">{{ t.self_organization_title }}</span>
                            <img :src="'/internacional/public/office5/img/franchise_dashboard/svg/info.svg'" style="margin-left: 3px"
                                 data-toggle="tooltip" data-placement="bottom" :title="t.self_organization_description"/>
                            <div class="switch__container">
                                <input id="switch-shadow" class="switch switch--shadow" :class="{ 'checked': checked || checked == null }" @click="toolSuggestionState()" type="checkbox">
                                <label for="switch-shadow"></label>
                            </div>
                        </div>
                    </div>
                    <div class="box_interna display_flex column_flex">
                        <draggable
                            class="list-group StackedList--hasScroll"
                            tag="div"
                            v-model="toolsList"
                            v-bind="dragOptions"
                            @start="isDragging = true"
                            @end="isDragging = false"
                            filter=".container__tutorials"
                        >
                            <transition-group type="transition" name="flip-list" class="container_tool" id="containerTool" tag="ul">
                                <li
                                    class="card_tool"
                                    v-for="(element, index) in toolsList"
                                    :key="index+1"
                                >
                                    <div class="card_content">
                                        <div class="header_tool" :class="{ 'is_locked': element.is_available === false  }">
                                            <div>
                                                <img :alt="element.title" :src="`/internacional/public/office5/img/tools/default/${element.image}`">
                                            </div>
                                            <h3 v-html="element.title"></h3>
                                        </div>
                                        <div class="tool_estructure available" v-if="element.is_available === true && !element.is_legacy"></div>
                                        <div class="tool_estructure" :class="{ 'locked_tool': element.is_available === false }" v-if="element.is_available === false">
                                            <div class="help__trainning">
                                                <button class="buttons_card unavailable">
                                                    <img :src="`/internacional/public/office5/img/general-svg/lock_yellow.svg`">
                                                    {{t.upgrade}}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="tool_estructure" :class="{ 'legacy_tool': element.is_legacy === true }" v-if="element.is_legacy === true">
                                            <div class="help__trainning">
                                                <button class="buttons_card unavailable_legacy">
                                                    <img :src="`/internacional/public/office5/img/general-svg/legacy_red.svg`">
                                                    Legacy
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
import draggable from "vuedraggable";
import qs from "qs";
import ToolsCards from "./ToolsCards.vue";
import MultilineSlideGridH from "../../../mixins/MultilineSlideGridH.js"
import { SpringSpinner } from 'epic-spinners';

export default {
    name: "dv5-tool",
    props: ["view"],
    display: "Transition",
    mixins: [MultilineSlideGridH],
    components: {
        draggable,
        ToolsCards,
        SpringSpinner,
    },
    data() {
        return {
            filters: [],
            tools: [],
            toolsList: [],//dados das Cards
            filter: 0,
            oldFilter: null,
            search: "",

            showModal: false,
            dataCard: {},
            isDragging: false,
            newToolsList: [],
            processing: false,
            ready: false,
            t: [], //translations
            timeoutId: null,
            langToShowNewCardFormat: false,
            checked: this.view.tool_order_suggestion,
            savingTools: false,
            listTutorials: false,
            RouteAPI: null,

            windowWidth: window.innerWidth,
            responsive: [
                {
                    'breakpoint': 100000,
                    'settings': {
                        'cols': 5,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 1920,
                    'settings': {
                        'cols': 4,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 1600,
                    'settings': {
                        'cols': 3,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 1366,
                    'settings': {
                        'cols': 2,
                        'rows': 2
                    }
                },
                {
                    'breakpoint': 1024,
                    'settings': {
                        'cols': 1,
                        'rows': 2
                    }
                },
                {
                    'breakpoint': 768,
                    'settings': {
                        'cols': 4,
                        'rows': 2,
                    }
                },
                {
                    'breakpoint': 500,
                    'settings': {
                        'cols': 3,
                        'rows': 2,
                    }
                },
                {
                    'breakpoint': 450,
                    'settings': {
                        'cols': 2,
                        'rows': 2,
                    }
                },
                {
                    'breakpoint': 200,
                    'settings': {
                        'cols': 1,
                        'rows': 1,
                    }
                },
            ]
        };
    },

    mounted() {
        this.t = this.view['translation'];
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
        $('[data-toggle="tooltip"]').tooltip();
        if(this.view['lang'] == 'us' || this.view['lang'] == 'br') this.langToShowNewCardFormat= true;
    },
    created() {
        this.concatRoute();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        concatRoute(){
            this.RouteAPI = '/' + this.view['lang'] + '/office/my-stuff/get-user-tools'
            this.initialize()
        },

        initialize() {
            var vm = this;
            vm.processing = true;

            axios
                .get(`${ vm.RouteAPI }`)
                .then(function(resposta) {
                    if (resposta.data.success) {
                        for(let i = 0; i < resposta.data.data.length; i++){
                            vm.tools.push(resposta.data.data[i].tools);
                            vm.$set(vm.filters, i, {
                                name: resposta.data.data[i].category,
                                mobile_name: resposta.data.data[i].category,
                                isActive: false,
                            })
                        }
                        vm.filters[0].isActive = true;
                        vm.oldFilter = 0;
                        vm.toolsList = resposta.data.data[0].tools;
                        vm.dataCard = vm.view;

                        // Card Number for Shimmer Loader: if it has no value in local storage, creates
                        let countDashboardTools = Object.keys(vm.toolsList).length;
                        if (parseInt(localStorage.getItem('shimmerCardNumber')) != countDashboardTools) {
                            localStorage.setItem('shimmerCardNumber', countDashboardTools)
                        }

                    } else {
                        alertMsg(
                            "error",
                            vm.t.get_tools_error
                        );
                    }
                })
                .catch(function(error) {
                    //console.log(error);
                })
                .finally(function() {
                    vm.getOrderByInteligence(0, false)
                    vm.setFilterByBadget()
                    vm.processing = false;
                    vm.ready = true;
                });
        },

        setFilterByBadget() {
            if ((this.tools[0].findIndex(x => x.is_new === true)) != -1) {
                this.$set(this.filters, this.filters.length, {
                    name: this.t.office_filter_new,
                    mobile_name: this.t.office_filter_new + ' (TAG)',
                    isActive: false,
                })
            }
            if ((this.tools[0].findIndex(x => x.beta_test === true)) != -1) {
                this.$set(this.filters, this.filters.length, {
                    name: this.t.office_filter_beta,
                    mobile_name: this.t.office_filter_beta + ' (TAG)',
                    icon: '/internacional/public/office5/img/general-svg/beta_icon.svg',
                    lateral_line: '/internacional/public/office5/img/general-png/beta_line.png',
                    isActive: false,
                })
            }
            if  ((this.filters.findIndex(x => x.name === this.t.label_legacy)) != -1) {
                this.filters.splice(this.filters.findIndex(x => x.name === this.t.label_legacy), 1);
                this.$set(this.filters, this.filters.length, {
                    name: this.t.label_legacy,
                    mobile_name: this.t.label_legacy + ' (TAG)',
                    icon: '/internacional/public/office5/img/general-svg/icon_legacy.svg',
                    isActive: false,
                })
            }
        },

        onResize() {
            this.windowWidth = window.innerWidth
        },

        toolsSelected(tool) {
            this.filter = tool;
            this.search = ""
            let value = []
            let index = null
            if (this.filters[tool].name != this.t.office_filter_beta && this.filters[tool].name != this.t.office_filter_new && this.filters[tool].name != this.t.label_legacy) {
                for (let i = 0; i < this.tools.length; i++){
                    if (i == tool) {
                        this.toolsList = this.tools[i]
                        this.changeStatusBtn(i)
                        this.filter = tool
                        i = this.tools.length
                    }
                }
            } else if (this.filters[tool].name == this.t.office_filter_beta) {
                index = this.filters.findIndex(x => x.name === this.t.office_filter_beta)
                for (let i = 0; i < this.tools[0].length; i++) {
                    if (this.tools[0][i].beta_test == true) {
                        value.push(this.tools[0][i])
                    }
                }
                this.changeStatusBtn(index)
                this.filter = index
                this.toolsList = value
            } else if (this.filters[tool].name == this.t.office_filter_new) {
                index = this.filters.findIndex(x => x.name === this.t.office_filter_new)
                for (let i = 0; i < this.tools[0].length; i++) {
                    if (this.tools[0][i].is_new == true) {
                        value.push(this.tools[0][i])
                    }
                }
                this.changeStatusBtn(index)
                this.filter = index
                this.toolsList = value
            } else if (this.filters[tool].name == this.t.label_legacy) {
                index = this.filters.findIndex(x => x.name === this.t.label_legacy)
                for (let i = 0; i < this.tools[0].length; i++) {
                    if (this.tools[0][i].is_legacy == true) {
                        value.push(this.tools[0][i])
                    }
                }
                this.changeStatusBtn(index)
                this.filter = index
                this.toolsList = value
            }
        },

        changeStatusBtn(indice) {
            if (this.oldFilter === null) {
                this.filters[indice].isActive = true
                this.oldFilter = indice
                this.$forceUpdate();
            } else if (this.oldFilter != null) {
                this.filters[this.oldFilter].isActive = !this.filters[this.oldFilter].isActive;
                this.filters[indice].isActive = true
                this.oldFilter = indice
            }
        },

        debounce(notify){
            if(this.timeoutId !== null)
            {
                clearTimeout(this.timeoutId);
            }
            this.timeoutId = setTimeout( _ => {
                this.updateReorder(notify)
            }, 2400);
        },

        updateReorder(notify){
            this.newToolsList = [];
            //relaciona o order com os keys do objeto
            for (var key in this.toolsList) {
                this.newToolsList[key] = {
                    id: this.toolsList[key].id,
                    order: parseInt(key) + 1
                };
            }

            var vm = this;
            vm.processing = true;
            vm.savingTools = true;

            axios
                .post(
                    vm.view['handler_routes']['rota_office_user_tools_save'],
                    qs.stringify({ tools: this.newToolsList })
                )
                .then(function(res) {
                    if(notify) {
                        if (res.data.success) {
                            alertMsg('success', vm.t.alert_self_organization);
                        } else {
                            alertMsg('error', vm.t.alert_self_organization_error);
                            console.log('error_self_organization', res);
                        }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                })
                .finally(function() {
                    vm.processing = false;
                    vm.savingTools = false;
                });
        },

        searchTool(title){
            let value = []
            for (let i = 0; i < this.tools[0].length; i++) {
                if (this.tools[0][i].title.toLowerCase().includes(title.toLowerCase())) {
                    value.push(this.tools[0][i])
                }
            }
            this.filter = 10 + title.length
            this.toolsList = value
        },

        toolSuggestionState() {
            let vm = this
            vm.savingTools = true;
            if (this.checked == null) {
                this.checked = false
            } else if (this.checked == false) {
                this.checked = true
                this.getOrderByInteligence(0, true)
            } else if (this.checked == true) {
                this.checked = false
                this.debounce(false)
            }
            axios
                .post(`${ '/' + vm.view.lang + '/office/tool-order-suggestion' }`,
                {tool_suggestion: vm.checked},
                )
                .then(function(resposta) {
                    if (resposta.data.success) {
                        alertMsg("success", vm.t.V5_DaD_saved);
                    } else {
                        alertMsg("error", vm.t.self_organization_error);
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
                .finally(function () {
                    vm.savingTools = false;
                })
        },

        findIndexTool(toolIDs, notify) {
            let index
            for (let i = 0; i < toolIDs.length; i++) {
                if  ((this.toolsList.findIndex(toolsList => toolsList.id === toolIDs[i])) != -1) {
                    index = this.toolsList.findIndex(toolsList => toolsList.id === toolIDs[i])
                    this.toolsList = this.reorderTool(this.toolsList, index, i)
                }
            }
            // this.debounce(notify)
        },

        reorderTool(arr, index2Remove, index2Add) {
            var element = arr[index2Remove];
            arr.splice(index2Remove, 1);
            arr.splice(index2Add, 0, element);
            return arr;
        },

        getOrderByInteligence(retries, notify) {
            if (this.checked || this.checked == null) {

                // let maxRetry       = 120,         // try for 12 seconds
                //     toolSuggestion = localStorage.getItem('toolSuggestion'),
                //     vm = this;

                // if(!toolSuggestion && retries <= maxRetry) {
                //     retries+=6;
                //     return setTimeout(function() {
                //         console.log('RETRY', retries, toolSuggestion);
                //         vm.getOrderByInteligence(retries, notify);
                //     }, 600);
                // }

                let toolSuggestion = '101,132,109,112,6,160,114,104';

                if(toolSuggestion != null && toolSuggestion != undefined) {
                    toolSuggestion = toolSuggestion.split(',');
                    this.findIndexTool(toolSuggestion, notify);
                }
            }
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },

        shimmerCardNumber() {
            // Card Number for Shimmer Loader: use local storage variable to v-for elements
            return localStorage.getItem('shimmerCardNumber') === null ? 3 : parseInt(localStorage.getItem('shimmerCardNumber'));
        },

        cardList(){
            return this.toolsList
        }
    },
    watch: {
        toolsList(newList, oldList) {
            if (oldList.length != 0 && this.filter === 0 && newList != this.tools[0] && this.search.length == 0) {
                this.debounce(true)
            } else {
                // console.log("não pode ser salvo hehehe")
            }
        },
        isDragging(){
            if (this.isDragging) {
                // this.collapseAllCards()
                this.listTutorials = false
            }
        },
        search(newSearch){
            if (newSearch.length < 1) {
                    if (this.filter >= 10) {
                        this.toolsSelected(0)
                    } else {
                        this.toolsSelected(this.filter)
                    }
            } else if (newSearch.length > 0){
                this.searchTool(newSearch)
            }
        }
    }
};
</script>
<style lang="scss">
.title_modal_remove > span{
    color: #FF4848;
    font-size: inherit;
}
.dv5-collapse-content {
    padding-top: 0 !important;
}
</style>
<style scoped lang="scss">
@import "../../../../scss/office";
@import "../../../../scss/extras/_variables";

@mixin background-center {
    background-repeat: no-repeat;
    background-position-x: center;
    background-origin: content-box;
}

.container__out {
    /* barra de admin ou va*/
    margin-bottom: 4rem;
    height: 100%;
    //padding: 0 70px;
}

.container__tool {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
    transition: 0.5s all ease;
    // grid-auto-rows: 300px;

    @media only screen and (max-width: 992px) {
        // grid-template-rows: 280px;
        grid-auto-rows: unset;
    }

    //shimmer loader
    &.container__tool--loading {
        padding: 1rem 4.4rem !important;

        .card__tool {
            .header__tool,
            .body__tool > h3,
            .body__tool > span,
            .footer__actions > a,
            .footer__actions__us > a,
            .card__actions .footer__help > div > a,
            .card__actions .footer__help > div > i {
                animation-duration: 1.25s;
                animation-fill-mode: forwards;
                animation-iteration-count: infinite;
                animation-name: placeHolderShimmer;
                animation-timing-function: linear;
                background: linear-gradient(to right, #edf1f5 8%, #f3f6f9 18%, #edf1f5 33%);
                background-size: 800px 104px;
                position: relative;
                border-radius: 4px;
            }
            .header__tool {
                height: 65px;
                width: 65px;
                margin: auto;
            }
            .body__tool {
                h3 {
                    height: 1.1rem;
                    width: 70%;
                    margin: 14px auto 10px auto !important;
                }
                span {
                    height: 0.62rem;
                    display: block;
                    margin: 8px 0;
                }
            }
            .card__actions {
                * {
                    border: none !important;
                }
                .footer__help > div {
                    margin-top: 0 !important;
                    a {
                        width: 42px;
                        height: 9px;
                    }
                    i {
                        width: 20px;
                        height: 20px;
                        margin-top: 10px;
                    }

                }
                .footer__actions > a {
                    width: 100%;
                    height: 1.8rem;
                }
                .footer__actions__us > a {
                    width: 100%;
                    height: 1.8rem;
                    display: flex;
                    .button3 {
                        width: 100%;
                        padding: 1rem 0.8rem;
                    }
                }
            }
        }
    }


    .card__tool {
        background: $dv5-color4;
        border-radius: 4px;
        padding: 0.3rem 0.6rem 0.8rem 0.6rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 4px;
        position: relative;

        &:active {
            cursor: all-scroll;
        }
        .trash__us {
            position: absolute;
            top: 20px;
            right: 20px;
            svg {
                width: 15px;
                height: auto;
                transition: .2s all;
                path {
                    transition: .2s all;
                }
                &:hover {
                    path {
                        fill: #FA4B57;
                    }
                }

            }
        }
        .card__content {

            padding: 10px;

            .header__tool {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                background-color: #ebf2fa;
                border-radius: 15px;

                img {
                    height: 150px;
                    margin-right: 10px;
                }
            }
            .body__tool {
                text-align: center;
                max-height: 125px;
                overflow: hidden;
                margin: 15px 0;

                h3 {
                    margin: 14px 0px 10px 0px;
                    font-size: 0.9rem;
                    line-height: 1.2rem;
                }
                span {
                    font-size: 12px;
                }
            }
        }

        .card__actions {
            display: flex;
            align-items: center;
            justify-content: space-around;
            .footer__help {
                display: flex;
                // border-top: 0.6px solid rgba(91, 91, 91, 0.5);

                div {
                    flex: 1;
                    display: inherit;
                    align-items: center;
                    padding: 0.5rem;
                    margin: 0.6rem 0;
                    flex-direction: column;

                    &.help__trainning {
                        border-left: 0.6px solid rgba(91, 91, 91, 0.5);
                    }


                    &.help__trainning > a, &.help__help > a {
                        svg {
                            display: none;
                            margin: auto;
                            margin-top: 8px;
                        }
                    }
                    a {
                        font-size: .55rem;
                        text-transform: uppercase;
                        color: $dv5-color1;
                        font-weight: bold;
                        &.disabled {
                            filter: opacity(0.5) grayscale(1);
                            pointer-events: none;
                        }
                    }
                }
                .help__help__us a {
                    display: flex;
                    align-items: center;
                    color: $dv5-color1;
                    font-weight: bold;
                    font-size: .95rem;
                    text-transform: capitalize;
                    svg {
                        margin-right: 10px;
                        width: 27px;
                        height: auto;
                    }
                }
            }

            .footer__actions {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 0.5rem;
            }
            .footer__actions__us {
                padding: 0 10px;
                .button3 {
                    width: 100%;
                    padding: 1rem 2rem;
                    background: #e6f3ff;
                    color: $dv5-color1;
                    border: 1px solid $dv5-color1;
                }
            }

        }
    }
}

.container__tutorials {
    grid-column: 1 / -1;
}

.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5 !important;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}
.button3 {
    font-size: 0.78rem;
    user-select:none;
}

@keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}

.button4 {
    background-color: $dv5-color4;

    border-radius: 4px;
    border: 1px solid $dv5-color4;

    margin: .1em .1em 0.1em .1em;
    min-height: 3em;
    height: initial;

    cursor: pointer;
    transition: 0.3s;

    &.simple {
        padding: .8em .4em .8em .4em;
        transition: 0.3s;
    }

    &.exit{
        padding: .3em .9em .8em .6em;
        transition: 0.3s;
    }

    &.badge{
        padding: 0 .4em 0 0;
        transition: 0.3s;
        display: inline-flex;
        align-items: center;
    }

    &.is-active {
        transition: 0.3s;
        border: 1px solid $dv5-color1;
        color: $dv5-color1;
    }

    &.legacy {
        color: $dv5-color11 !important;
    }

    .lateral_bar {
        width: 8px;
        height: 100%;
        border-radius: 4px 0px 0px 4px;

        &.new {
            background-color: $dv5-color1;
        }

        &.legacy {
            background-color: $dv5-color11;
        }
    }

    .beta_img {
        margin: 0 !important;
    }

    .beta_icon {
        width: 18px;
        margin: 0 .4em 0 .4em;
    }

    span {
        font-family: 'Muli';
        font-size: 15px;
        font-weight: 600;
        color: $dv5-color2;

        &.legacy {
            color: $dv5-color11;
        }

        &.new {
            margin-left: .4em;
        }
    }

    input {
        border: none;
    }
    img {
        margin: 0 .2em;
    }
}

.slide-wrapper{
    font-size: 10px;
    font-family: $dv5-font1;
    background-color: rgba(#B8BBBF, 0.05)!important;
    padding: 10px 0!important;
    border-radius: 8px!important;
}

.top_filter {
    padding: 0 4.3rem ;
    margin: .5rem 0;
}

.display_flex {
    display: flex;
    &.row_flex          { flex-direction: row; }
    &.column_flex       { flex-direction: column; }
    &.item_center       { align-items: center; }
    &.item_strech       { align-items: stretch; }
    &.item_start        { align-items: flex-start; }
    &.content_center    { align-content: center; }
    &.content_start     { align-content: flex-start; }
    &.content_end       { justify-content: flex-end; }
    &.justify_c_center  { justify-content: center; }
    &.justify_c_space   { justify-content: space-evenly; }
    &.justify_c_between { justify-content: space-between; }
    &.justify_c_start   { justify-content: flex-start; }
    &.wrap              { flex-wrap: wrap; }
    &.nowrap            { flex-wrap: nowrap; }
}
.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 98;
    background-color: rgba(0, 0, 0, 0.3);
}
.box_congratulation {
    background-color: $dv5-color4;
    border-radius: 10px;
    width: 80%;
    max-height: 90%;
    min-height: 60%;
    height: 50%;
    margin-top: 3%;
    padding: 1rem;
}

.center {
    text-align: center;
}

.box_interna {
    margin: 0 1em 1em 1em;
    overflow-y: scroll;
}

.edit_btn {
    max-height: 1.5rem;
    height: auto;
}

.save_btn {
    background-color: $dv5-color9;
    border: none;
    border-radius: 10px;
    color: $dv5-color4;
    height: 3rem;
    width: 8rem;
    margin: 0 3rem;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.dv5_DaD_title{
    font: $dv5-font2;
    font-size: 2em;
    font-weight: 800;
    line-height: 1.5;
    color: $dv5-color2;

    display: inline-flex;

    .loader {
        margin-left: .5em;
        margin-top: 5px;
    }
}
.dv5_DaD_subtitle{
    font: $dv5-font1;
    font-size: 1em;
    font-weight: 800;
    line-height: 1.5;
    color: $dv5-color2;
}
.container_tool {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    transition: 0.5s all ease;

    @media only screen and (max-width: 992px) {
        grid-auto-rows: unset;
    }

    .card_tool {
        background: $dv5-color4;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 4px;
        position: relative;

        &:active {
            cursor: all-scroll;
        }

        .card_content {

            padding: 10px;

            .header_tool {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                border-radius: 15px;

                img {
                    height: 150px;
                }
                h3 {
                    margin: -1.5em 0 0 0;
                    font-size: 0.9rem;
                    line-height: 1.2rem;
                }
            }
            .is_locked {
                opacity: .7;
            }
        }
    }
}
.modal-overlay{
    z-index: 1500!important;
}
.filters_1 {
    max-height: 3vw;
}
.tool_estructure {
    top: 10px;
    width: 90%;
    height: 94%;
    position: absolute;
    border-radius: 8px;

    &.locked_tool,
    &.legacy_tool,
    &.available {
        opacity: 0;
    }
    &.available:hover {
        opacity: 1;
        transition: opacity .3s;
        border: 1px solid $dv5-color1;
    }
    &.locked_tool:hover {
        opacity: 1;
        transition: opacity .3s;
        border: 1px solid #30BC06;
        .buttons_card {
            border-radius: 6px;
            margin: 40% 10%;
            align-items: center;
            justify-content: center;
            height: 2.6rem;
            width: 80%;
        }
        .unavailable {
            display: flex;
            flex-direction: row !important;
            justify-content: space-evenly !important;
            background-color: $dv5-color9;
            color: $dv5-color7;
            text-align: center;
            padding: 0 1rem;
            border: none;
        }
    }
    &.legacy_tool:hover {
        opacity: 1;
        transition: opacity .3s;
        border: 1px solid $dv5-color11;
        .buttons_card {
            border-radius: 6px;
            margin: 40% 10%;
            align-items: center;
            justify-content: center;
            height: 2.6rem;
            width: 80%;
        }
        .unavailable_legacy {
            display: flex;
            flex-direction: row !important;
            justify-content: space-evenly !important;
            background-color: $dv5-color11;
            color: $dv5-color7;
            text-align: center;
            padding: 0 1rem;
            border: none;
        }
    }
}
.modal-title {
    display: inline-flex;
}
.card-title {
    width: 59%;
}
//.tool-suggestion {
//    width: 40%;
//    display: flex;
//    align-items: flex-end;
//    justify-content: flex-end;

    .tool-suggestion-container {
        display: inline-flex;
        align-items: center;
        background-color: #E9EDF2;
        padding: 0 12px;
        border-radius: 25px;
        margin-top: 12px;

        .switch__container {
            margin-left: 10px;
            width: 60px;
            padding-top: 5px;
        }

        .switch {
            visibility: hidden;
            position: absolute;
            margin-left: -9999px;
        }

        .switch + label {
            display: block;
            position: relative;
            cursor: pointer;
            outline: none;
            user-select: none;
        }

        .switch--shadow + label {
            padding: 2px;
            width: 60px;
            height: 30px;
            background-color: #dddddd;
            border-radius: 30px;
        }
        .switch--shadow + label:before,
        .switch--shadow + label:after {
            display: block;
            position: absolute;
            top: 1px;
            left: 1px;
            bottom: 1px;
            content: "";
        }
        .switch--shadow + label:before {
            right: 1px;
            background-color: #f1f1f1;
            border-radius: 30px;
            transition: background 0.4s;
        }
        .switch--shadow + label:after {
            width: 29px;
            height: 27px;
            margin-top: 0.5px;
            background-color: #fff;
            border-radius: 100%;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
            transition: all 0.4s;
        }
        .checked + label:before {
            background-color: #8ce196;
        }
        .checked + label:after {
            transform: translateX(30px);
        }
    }
//}
#content {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/tool/index.vue